export const FIRST_CHECKIN = 5;
export const SECOND_CHECKIN = 15;

export const FIRST_CHECKIN_NORMAL_THRESHOLD = 10;
export const FIRST_CHECKIN_EXTENDED_THRESHOLD = 20;

export const SECOND_CHECKIN_NORMAL_THRESHOLD = 15;
export const SECOND_CHECKIN_EXTENDED_THRESHOLD = 30;
